import { render } from "./WaitingScreen.vue?vue&type=template&id=2b443640&ts=true"
import script from "./WaitingScreen.vue?vue&type=script&lang=ts"
export * from "./WaitingScreen.vue?vue&type=script&lang=ts"

import "./WaitingScreen.vue?vue&type=style&index=0&id=2b443640&lang=css"

import exportComponent from "C:\\Users\\berge\\Desktop\\My Projects\\o2p-shop-planner\\SP.App\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__